import 'bootstrap/dist/css/bootstrap.min.css';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';

import Container from 'react-bootstrap/Container';
import { Row, Col } from 'react-bootstrap';
import {Link} from "react-router-dom";
import PageFooter from "./components/pageFooter";

export function getData() {
    return [
        { image: '/lenas.jpg', imageOnHover: '/lena3.jpeg', title: 'Concept: Ethereal Grunge' },
        { image: '/flower.jpeg', imageOnHover: '/flower4.JPG', title: 'Concept: Cherry Blossom' },
        { image: '/mermaid.jpg', imageOnHover: '/mermaid2.jpeg', title: 'Concept: Blue Mermaid' },
        { image: '/fish.jpeg', imageOnHover: '/fish2.jpg', title: 'Concept: Tinned Fish' },
        { image: '/jen.jpeg', imageOnHover: '/jen2.jpeg', title: 'Concept: Straps & Flowers' },
        { image: '/ren.jpg', imageOnHover: '/ren2.jpeg', title: 'Concept: CyberSigilism Tattoos' },
        { image: '/first.JPG', imageOnHover: '/first2.jpeg', title: 'Concept: Dreamy amphibian' },
        { image: '/lillian2.jpeg', imageOnHover: '/lillian.JPG', title: 'Concept: Year of the Snake' },
        { image: '/pink.jpg', imageOnHover: '/pink2.jpg', title: 'Concept: Pink' },
        { image: '/blue2.jpg', imageOnHover: '/bluee1.jpg', title: 'Concept: Blue' },
        { image: '/white.jpg', imageOnHover: '/white2.jpg', title: 'Concept: White' },
    ];
}
const ProductContent = (props) => {
    return (
        <Col sm className={'col'}>
            <div className={'imageWrapper'}>
                <img className={'mainImage'} src={require("../images" + props.data.image)} alt={""}></img>
                <img className={'hoverImage'} src={require("../images" + props.data.imageOnHover)} alt={""}></img>
            </div>
            <div className={'tileTitleWrapper'}>
                <div className={'tileTitle'}> { props.data.title }</div>
            </div>
        </Col>
    )
}

const Products = (props) => {
    const data = getData();
    return (
        <Container fluid className={'productPageContainer'}>
            <Row xs={2} sm={3} md={3} className={'row'}>
                <Col className={'col'}>
                    <Link target="_blank" to="https://forms.gle/dZzkgGPmD9CiGAK36" className='navigationHeaderLink'>
                        <div className={'NailCommission-imageWrapper'}>
                            <img className={'NailCommission-mainImage'} src={require('../images/MiffyClicked.png')}
                                 alt={""}></img>
                            <img className={'NailCommission-hoverImage'} src={require('../images/9224962.jpg')}
                                 alt={""}></img>
                        </div>
                        <div className={'NailCommission-tileTitleWrapper'}>
                            <a className={'NailCommission-tileTitle'}>+</a>
                        </div>
                    </Link>
                </Col>
                {data.map((object, i) => (
                    <ProductContent key={i} data={object} />
                ))}
            </Row>

            <Row className={'rowTitle'}>
                <Col sm className={'colTitle'}>
                    <a className={'navTitle'}> odd nails</a>
                    <a className={'subTitle'}> because the odd ones always leave an impression</a>
                </Col>
            </Row>
        </Container>
    )
}
export const ProductPage = () => {
    return (
        <>
            <PageLayout>
                <PageContainer>
                    <PageBody>
                        <NavigationHeader></NavigationHeader>
                            <PageText>
                                <Products />
                            </PageText>
                        <PageFooter />
                    </PageBody>
                </PageContainer>
            </PageLayout>
        </>
    )
}